(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cosmic-closet"] && !Shopify.designMode) return;
  try {
    
  let cosmicAssetLoading = false;
  async function loadCosmicCloset() {
    if (cosmicAssetLoading || customElements.get('cosmic-closet-game')) return;
    const game = document.querySelector('cosmic-closet-game[data-source-urls]');
    if (!game) return;
    cosmicAssetLoading = true;
    try {
      const urls = JSON.parse(game.dataset.sourceUrls);
      const parts = await Promise.all(urls.map((u) => fetch(u).then((r) => {
        if (!r.ok) throw new Error('Cosmic Closet asset fetch failed: ' + u);
        return r.text();
      })));
      const code = parts.join('');
      const script = document.createElement('script');
      script.textContent = code;
      document.head.append(script);
    } catch (err) {
      cosmicAssetLoading = false;
      game.textContent = 'The arcade could not load. Please refresh to try again.';
    }
  }
  loadCosmicCloset();
  document.addEventListener('shopify:section:load', loadCosmicCloset);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["madhouse-tee-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag = 'madhouse-tee-hero';
  if (customElements.get(tag)) return;
  const tau = Math.PI * 2;
  const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
  const smooth = (lo, hi, x) => { const t = clamp((x-lo)/(hi-lo),0,1); return t*t*(3-2*t); };

  class MadhouseHero extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.controller) return;
        const root = document.getElementById(this.id);
        if (root !== this) return;
        this.controller = start(root);
      });
    }
    disconnectedCallback() {
      this.controller?.destroy();
      this.controller = null;
    }
  }

  function start(root) {
    const stage = root.querySelector('.mh-stage');
    const keyboard = root.querySelector('.mh-keyboard');
    const images = Array.from(root.querySelectorAll('.mh-tee'));
    const total = images.length;
    if (!stage || !keyboard || !total) return { destroy() {} };
    const entries = images.map(image => ({ image, loaded: image.hasAttribute('src'), visible: false }));
    const abort = new AbortController();
    const listen = (node, name, handler, options = {}) => node.addEventListener(name, handler, { ...options, signal: abort.signal });
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const step = tau / total;
    const pop = clamp(Number(root.dataset.pop || 8), 0, 16) / 100;
    const wrap = n => ((n % total) + total) % total;
    const shortest = a => Math.atan2(Math.sin(a), Math.cos(a));
    let w=1, h=1, mobile=false, angle=0, target=0, speed=0;
    let dragging=false, captured=false, pointer=null, downX=0, downY=0, lastX=0, lastMove=0, pointerSpeed=0, downAngle=0;
    let frame=0, previous=0, visible=true, destroyed=false, keyboardActive=false;
    let intro = root.dataset.intro !== 'false' && !reduced.matches && !window.Shopify?.designMode && total>1;
    let introStart=null;
    keyboard.max=String(total-1);
    keyboard.disabled=total<2;

    function load(entry) {
      if (entry.loaded) return;
      entry.loaded=true;
      const image=entry.image;
      if (image.dataset.srcset) image.srcset=image.dataset.srcset;
      image.src=image.dataset.src;
    }
    function draw() {
      const rx=w*(mobile?.60:.405), ry=h*(mobile?.075:.073);
      const base=mobile?Math.min(w*.68,h*.66):Math.min(w*.33,h*.66);
      entries.forEach((entry,i)=>{
        const a=shortest(angle+i*step), z=Math.cos(a), side=Math.sin(a);
        if (z>-.18) load(entry);
        // Cull the entire rear half of the orbit; no rear garment is rendered.
        if (z<=.025) {
          if(entry.visible || entry.image.style.visibility!=='hidden'){
            entry.image.style.visibility='hidden';entry.image.style.opacity='0';entry.image.style.willChange='auto';
          }
          entry.visible=false;
          return;
        }
        const focus=Math.exp(-Math.pow(a/(step*.72),2));
        const scale=.85+.15*z+pop*focus;
        const x=side*rx,y=z*ry-focus*h*.012;
        const image=entry.image;
        if(!entry.visible){image.style.visibility='visible';image.style.willChange=reduced.matches?'auto':'transform';entry.visible=true;}
        image.style.width=base+'px';
        image.style.transform=`translate(-50%,-50%) translate3d(${x.toFixed(3)}px,${y.toFixed(3)}px,0) perspective(1000px) rotateY(${(-side*30).toFixed(3)}deg) rotateZ(${(-side*(mobile?2.3:1.6)).toFixed(3)}deg) scale(${scale.toFixed(4)})`;
        image.style.zIndex=String(Math.round(z*1000));
        image.style.opacity=String(smooth(.025,.20,z));
        image.style.filter=`brightness(${(.86+.14*focus).toFixed(3)}) drop-shadow(0 ${(17+5*focus).toFixed(1)}px ${(12+3*focus).toFixed(1)}px #0007)`;
      });
      const selected=wrap(Math.round(-angle/step));
      if(!keyboardActive)keyboard.value=String(selected);
      keyboard.setAttribute('aria-valuetext',`${images[selected].dataset.label || 'Graphic tee'}, ${selected+1} of ${total}`);
    }
    function wake(){if(!frame&&!destroyed&&visible&&!document.hidden)frame=requestAnimationFrame(tick);}
    function tick(now){
      frame=0;
      if(destroyed||!root.isConnected||!visible||document.hidden)return;
      const dt=previous?clamp((now-previous)/1000,1/240,.04):1/60;previous=now;
      let moving=false;
      if(intro){
        if(introStart===null)introStart=now;
        const u=clamp((now-introStart)/2600,0,1),ease=u*u*(3-2*u);
        angle=-step*ease;target=angle;moving=u<1;
        if(u===1){intro=false;target=-step;angle=target;}
      }else if(reduced.matches){angle=target;speed=0;}
      else if(dragging){angle+=(target-angle)*(1-Math.exp(-42*dt));speed=0;moving=Math.abs(target-angle)>.00001;}
      else if(Math.abs(angle-target)>.00001 || Math.abs(speed)>.0001){
        const omega=17,change=angle-target,temp=(speed+omega*change)*dt,decay=Math.exp(-omega*dt);
        angle=target+(change+temp)*decay;speed=(speed-omega*temp)*decay;
        moving=Math.abs(angle-target)>.00001||Math.abs(speed)>.0001;
        if(!moving){angle=target;speed=0;keyboardActive=false;}
      }
      draw();
      if(moving)wake();
      else entries.forEach(entry=>entry.image.style.willChange='auto');
    }
    function measure(){w=stage.clientWidth;h=stage.clientHeight;mobile=w<=600;draw();wake();}
    function stopIntro(){intro=false;introStart=null;keyboardActive=false;}
    function snap(next, initialSpeed=0){stopIntro();target=next;speed=reduced.matches?0:initialSpeed;previous=0;wake();}
    function end(cancel=false){
      if(!dragging)return;
      dragging=false;stage.classList.remove('is-dragging');
      const releasedPointer=pointer;pointer=null;
      if(captured && releasedPointer!==null && stage.hasPointerCapture(releasedPointer))stage.releasePointerCapture(releasedPointer);
      const v=cancel||performance.now()-lastMove>90||!captured?0:pointerSpeed;
      const destination=cancel?angle:target+(reduced.matches?0:clamp(v*.14,-step*3,step*3));
      snap(Math.round(destination/step)*step,v);captured=false;
    }
    listen(stage,'pointerdown',event=>{
      if(event.button!==0 || event.target===keyboard || total<2)return;
      stopIntro();dragging=true;captured=false;pointer=event.pointerId;downX=lastX=event.clientX;downY=event.clientY;lastMove=performance.now();pointerSpeed=0;speed=0;downAngle=angle;target=angle;
      stage.classList.add('is-dragging');
    });
    listen(stage,'pointermove',event=>{
      if(!dragging||event.pointerId!==pointer)return;
      const dx=event.clientX-downX,dy=event.clientY-downY,now=performance.now();
      if(!captured){
        if(Math.abs(dy)>Math.abs(dx)+7){end(true);return;}
        if(Math.abs(dx)<5)return;
        captured=true;stage.setPointerCapture(event.pointerId);
      }
      const gain=mobile?.0057:.0037;
      const elapsed=clamp((now-lastMove)/1000,.008,.08);
      const sampled=clamp((event.clientX-lastX)*gain/elapsed,-3.2,3.2);
      pointerSpeed=pointerSpeed*.65+sampled*.35;
      target=downAngle+dx*gain;lastX=event.clientX;lastMove=now;wake();
    });
    listen(stage,'pointerup',()=>end());
    listen(stage,'pointercancel',()=>end(true));
    listen(stage,'lostpointercapture',()=>{if(dragging)end(true);});
    listen(stage,'pointerleave',()=>{if(dragging&&!captured)end(true);});
    listen(keyboard,'input',()=>{const next=-Number(keyboard.value)*step;stopIntro();keyboardActive=true;target=angle+shortest(next-angle);speed=0;previous=0;wake();});
    listen(root,'shopify:block:select',event=>{
      const i=images.findIndex(image=>image.dataset.blockId===event.detail?.blockId);
      if(i>=0)snap(angle+shortest(-i*step-angle));
    });
    listen(document,'visibilitychange',()=>{if(document.hidden){if(frame)cancelAnimationFrame(frame);frame=0;stopIntro();target=Math.round(target/step)*step;previous=0;}else wake();});
    listen(reduced,'change',()=>{if(reduced.matches){stopIntro();target=Math.round(target/step)*step;speed=0;}wake();});
    const resize=new ResizeObserver(measure);resize.observe(stage);
    const intersection=new IntersectionObserver(records=>{
      visible=records[0]?.isIntersecting!==false;
      if(!visible){if(frame)cancelAnimationFrame(frame);frame=0;previous=0;}
      else{previous=0;wake();}
    },{rootMargin:'80px'});intersection.observe(root);
    root.classList.add('is-ready');measure();
    return {destroy(){destroyed=true;abort.abort();resize.disconnect();intersection.disconnect();if(frame)cancelAnimationFrame(frame);root.classList.remove('is-ready');}};
  }
  customElements.define(tag,MadhouseHero);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
